import React from 'react';
import './VideoScreen.css';

const VideoScreen = () => {
  return (
    <div className="video-screen-container">
      <div className="video-content">
        <div className="video-icon-container">
          <img 
            src="/img/video.svg" 
            alt="Video Icon" 
            className="video-icon"
          />
        </div>
        <h1 className="video-title">Meet the Team & Our Approach</h1>
        <p className="video-description">
          See how we review catalogs and help artists earn more—personally, transparently, and hands-on.
        </p>
        
        <div className="video-frame-container">
          <div className="video-frame">
            <iframe
              className="video-iframe"
              src="https://www.youtube.com/embed/65g4IqxeaX0"
              title="Company Vision Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
            
          </div>
        </div>
        <div className="video-frame-button">
              <a href="#contact" className="book-call-link">
                Book your free call
              </a>
            </div>
      </div>
    </div>
  );
};

export default VideoScreen; 